import React from 'react'
import PropTypes from 'prop-types'
import Helmet from "react-helmet";
import PortfolioPhoto from "../components/PortfolioPhoto";
import Lazyload from "react-lazyload";
import PlaceholderComponent from "../components/PlaceholderComponent";
import IconClose from "../img/icons/close.png";
import ListOfCommissionedJobs from "../components/ListOfCommissionedJobs";
import MarkdownContent from "../components/MarkdownContent";

class PortfolioPageTemplate extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            zoomedPhotoIndex: null,
            zoomedPhoto: null,
            slice: this.props.type === 'commissioned' ? 1 : 0
        };

        this.onClickedToZoom = this.onClickedToZoom.bind(this);
        this.onClosed = this.onClosed.bind(this);
        this.onClickedToNext = this.onClickedToNext.bind(this);
        this.onClickedToPrev = this.onClickedToPrev.bind(this);
        this.keyHandling = this.keyHandling.bind(this);

    }

    onClickedToZoom(index) {
        console.log(index);
        // trigger window scroll so lazy load is active for zoomed images
        window.scrollTo(window.scrollX, window.scrollY + 1);

        this.setState({
            zoomedPhotoIndex: index,
            zoomedPhoto: this.props.photos[index]
        });
    }

    onClickedToNext() {
        let next = this.state.zoomedPhotoIndex + 1;

        this.setState({
            zoomedPhotoIndex: next,
            zoomedPhoto: this.props.photos[next]
        });
    }

    onClickedToPrev() {
        let prev = this.state.zoomedPhotoIndex - 1;

        this.setState({
            zoomedPhotoIndex: prev,
            zoomedPhoto: this.props.photos[prev]
        });
    }

    onClosed() {
        this.setState({
            zoomedPhotoIndex: null,
            zoomedPhoto: null
        });
    }

    keyHandling(e) {
        if (this.state.zoomedPhotoIndex == null)
            return;

        switch (e.keyCode) {
            case 37:
                this.onClickedToPrev();
                break;

            case 39:
                this.onClickedToNext();
                break;
        }
    }

    componentDidMount() {
        window.addEventListener("keydown", this.keyHandling);

    }

    componentWillUnmount() {
        window.removeEventListener("keydown", this.keyHandling);
    }

    render() {
        return (
            <div>
                <Helmet
                    title={`${this.props.title} | Jennifer Emerling | Visual Storyteller in California`}
                    bodyAttributes={{
                        class: `page-portfolio theme-${this.props.theme}`
                    }}/>

                <section className="section body section-content-wrapper">

                    {
                        this.props.type === 'commissioned' ?
                            <div onClick={() => this.onClickedToZoom(0)}
                                 style={{cursor: 'pointer'}}>
                                <PortfolioPhoto url={this.props.photos[0].url}
                                                thumbnailUrl={this.props.photos[0].thumbnailUrl}
                                                alt={this.props.photos[0].alt}
                                                columnSize={this.props.photos[0].columnSize}
                                                caption={this.props.photos[0].caption}
                                />
                                <MarkdownContent className={"content has-padding-top-lg has-padding-bottom-lg"}
                                                 content={this.props.description}/>
                            </div>
                            :
                            null
                    }


                    <div className="has-margin-bottom-md columns is-multiline">
                        {
                            this.props.photos.slice(this.state.slice).map((photo, index) => {
                                return (
                                    <div key={index} className={`column ${photo.columnSize}`}
                                         style={{cursor: 'pointer'}}
                                         onClick={() => this.onClickedToZoom(index + this.state.slice)}>

                                        <PortfolioPhoto index={index}
                                                        url={photo.url}
                                                        thumbnailUrl={photo.thumbnailUrl}
                                                        alt={photo.alt}
                                                        columnSize={photo.columnSize}
                                                        caption={photo.caption}
                                        />

                                    </div>
                                )
                            })}
                        {
                            this.state.zoomedPhoto != null ?
                                <div className={`modal is-active`}>
                                    <div className="modal-background"></div>
                                    <div className="modal-content">
                                        <div className="image is-full">
                                            <Lazyload height={400} offset={0} once
                                                      placeholder={<PlaceholderComponent/>}>
                                                <img className="zoomedImage" src={this.state.zoomedPhoto.url}
                                                     title={this.state.zoomedPhoto.alt}
                                                     alt={this.state.zoomedPhoto.alt}
                                                     style={{
                                                         width: 'auto',
                                                         margin: 'auto',
                                                     }}/>
                                            </Lazyload>
                                        </div>
                                    </div>
                                    <img src={IconClose}
                                         className="modal-close is-medium"
                                         style={{borderRadius: 0}}
                                         onClick={() => this.onClosed()} aria-label="close"/>

                                    <div className="carousel-navigation is-overlay">
                                        <div className="carousel-nav-left"
                                             onClick={() => this.onClickedToPrev()}>
                                            <i className="fa fa-3x fa-chevron-left" aria-hidden="true"></i>
                                        </div>
                                        <div className="carousel-nav-right"
                                             onClick={() => this.onClickedToNext()}>
                                            <i className="fa fa-3x fa-chevron-right" aria-hidden="true"></i>
                                        </div>
                                    </div>
                                </div>
                                : ''
                        }
                    </div>

                    {
                        this.props.type === 'commissioned' ?

                            <div className="jobs has-padding-top-xxl">
                                <ListOfCommissionedJobs jobs={this.props.jobs}/>
                            </div>
                            :
                            null
                    }
                </section>
            </div>
        )
    }
}


PortfolioPageTemplate.propTypes = {
    type: PropTypes.string,
    title: PropTypes.string,
    description: PropTypes.string,
    theme: PropTypes.string,
    photos: PropTypes.array,
    jobs: PropTypes.array
}

const PortfolioPage = ({data}) => {
    const {markdownRemark: page} = data;
    return (
        <PortfolioPageTemplate
            type={page.frontmatter.type}
            title={page.frontmatter.title}
            description={page.frontmatter.description}
            photos={page.frontmatter.photos}
            theme={page.frontmatter.theme}
            jobs={data.allMarkdownRemark.edges.map(edge => edge.node.frontmatter)}
        />
    )
}

PortfolioPage.propTypes = {
    data: PropTypes.object
}

export default PortfolioPage

export const portfolioPageQuery = graphql`
  query PortfolioPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        type
        title
        description
        photos{
          alt
          thumbnailUrl
          url
          columnSize
          caption
        }
        theme
      }
    },
    
    allMarkdownRemark(filter: {frontmatter: {type: {eq: "commissioned"}}}, sort: {fields: [frontmatter___order], order: ASC}) {
      edges {
        node {
          id
          frontmatter {
            order
            title
            path
            mainImageUrl
            hoverImageUrl
          }
        }
      }
    }
  }
`


const commissionedIndexPageQuery = graphql`
  query CommissionedIndexPage($id: String!) {
    markdownRemark(id: { eq: $id }) {
      frontmatter {
        title
        description
        photos{
          mainImageUrl
          hoverImageUrl
          caption
          color
          link
        }
      }
    }
    allMarkdownRemark(filter: {frontmatter: {type: {eq: "commissioned"}}}, sort: {fields: [frontmatter___order], order: ASC}) {
      edges {
        node {
          id
          frontmatter {
            order
            title
            path
            mainImageUrl
            hoverImageUrl
          }
        }
      }
    }
    
  }
`



// WEBPACK FOOTER //
// ./src/templates/portfolio-page.js